<template>
  <div class="report-left-row">
    <h1>{{ test?.name }}</h1>

    <!-- cards grid row -->
    <router-link :to="`/function/efficiency/${route.params.barcode}`">
      <div @click="handleGeneralDetailsClick" class="cards-report-grid-row" :class="route.path == `/function/efficiency/${route.params.barcode}` ||
          route.path == `/blood/test/report/${route.params.barcode}`
          ? 'active-reports'
          : ''
        ">
        <div>
          <div class="gallery-icon">
            <img :src="GalleryIcon" alt="Gallery Icon" />
          </div>
        </div>
        <div>
          <p>General Details</p>
        </div>
      </div>
    </router-link>

    <div v-for="(panel, index) in selectedBloodTest.result.panels" :key="index">
      <div class="cards-report-grid-row" :class="panel.name === route.params.panel ? 'active-reports' : ''"
        @click="selectPanel(panel.name)">
        <div>
          <div class="gallery-icon">
            <img :src="GalleryIcon" alt="Gallery Icon" />
          </div>
        </div>
        <div>
          <p>{{ panel.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { defineEmits, nextTick } from "vue";
import GalleryIcon from "../../../assets/images/Health/diet.png";
import { usePatientStore } from "@/store/health/blood";

const emit = defineEmits(["selectPanel"]);
const patientStore = usePatientStore();

const route = useRoute();
const router = useRouter();

const selectedBloodTest = patientStore.getTestByBarcode(route.params.barcode);
const selectPanel = (panelName) => {
  const barcode = route.params.barcode;
  emit("selectPanel", panelName, barcode);
  patientStore.setSelectedBloodTest(barcode);
};

const handleGeneralDetailsClick = async (event) => {
  event.preventDefault();
  await router.push(`/function/efficiency/${route.params.barcode}`);
  nextTick(() => {
    const section = document.getElementById("report-wrapper-row");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  });
};
</script>
